import {
  ConfirmationDialog,
  InputConfirmation,
  useCurrentOrPrevious,
} from '@dittolive/anvil'
import React, { useState } from 'react'

type Props = {
  /** Indicates whether the modal is open or closed. */
  show: boolean
  /** Callback for closing the modal */
  onClose: () => void
  /** Callback for confirming the modal */
  onConfirm: () => void
  /** Webhook name being deleted. */
  webhook: string
}

/**
 * Confirmation modal for deleting an auth webhook.
 * Requires typing the webhook name to confirm deletion.
 */
export default function DeleteProviderModal({
  show,
  onClose,
  onConfirm,
  webhook,
}: Props) {
  const [isMatch, setIsMatch] = useState(false)
  // NOTE: the open state is managed by the webhook being selected, so if the current is empty
  // we render the previous while the modal is closing so the content doesn't flash
  const displayedWebhook = useCurrentOrPrevious(webhook)

  return (
    <ConfirmationDialog
      size="md"
      open={show}
      onCancel={onClose}
      onConfirm={onConfirm}
      confirmButtonText="Delete webhook"
      confirmButtonDisabled={!isMatch}
      data-testid="deleteWebhookConfirmationModal"
      title={`Delete Webhook ${displayedWebhook}`}
      description={
        <>
          Are you sure you want to delete this webhook?{' '}
          <span className="text-foreground-normal font-medium">
            This action cannot be undone.
          </span>
        </>
      }
      variant="warning"
    >
      <InputConfirmation value={displayedWebhook || ''} onMatch={setIsMatch} />
    </ConfirmationDialog>
  )
}
